<template>
    <div>
        <div class="lunbo banner-wrapper">
            <div class="hidden-xs-only nav">
                <el-carousel :interval="9000" height="var(--banner-height)" :autoplay="autoplay">
                    <el-carousel-item v-for="(item, index) in banner" :key="index">
                        <el-image style="cursor:pointer;width:100%;" ref="image" :src="item.ori_img"
                            @click="bantiao(item.carousel_href)"></el-image>
                    </el-carousel-item>
                </el-carousel>
            </div>
            <div class="hidden-sm-and-up">
                <el-carousel :interval="9000" height="230px" indicator-position="none" :autoplay="autoplay">
                    <el-carousel-item v-for="(item, index) in banner" :key="index">
                        <el-image style="cursor:pointer;width:100%" ref="image" :src="item.carousel_img"
                            @click="bantiao(item.carousel_href)"></el-image>
                    </el-carousel-item>
                </el-carousel>
            </div>
        </div>
        <div class="appmain home-title-wrapper" v-if="$i18n.locale == 'zh' || $i18n.locale == 'en'">
            <div class="hometitle" @click="nav('productinfo')">{{ $t('index.BusinessBlock') }}</div>
            <el-row :gutter="20" style="margin-top:3%">
                <el-col :span="6" :xs="12" style="margin-bottom:20px">
                    <div style="background:#ffffff;height: 170px;">
                        <div style="cursor: pointer;text-align:center;flex-direction:column;" @click="nav('energy')">
                            <el-image class="t1" style="width: 80px;height: 60px;margin-top: 15px;"
                                :src="require('@/assets/index/icon_Hybridenergy.png')"></el-image>
                            <div
                                :style="$i18n.locale == 'zh' || $i18n.locale == 'hk' ? BusinessStyle1 : BusinessStyle2">
                                {{ $t('index.energy') }}</div>
                            <div
                                :style="$i18n.locale == 'zh' || $i18n.locale == 'hk' ? BusinessStyle3 : BusinessStyle4">
                                {{ $t('index.energy_description') }}</div>
                        </div>
                    </div>
                </el-col>
                <el-col :span="6" :xs="12" style="margin-bottom:20px">
                    <div style="background:#ffffff;height: 170px;" class="flex-row justify-center align-center">
                        <div style="cursor: pointer;text-align:center;flex-direction:column;"
                            @click="nav('productinfo?class_id=1&page=1&id=0')">
                            <el-image class="t1" style="width: 80px;height: 60px;margin-top: 15px;"
                                :src="require('@/assets/index/icon_genset.png')"></el-image>
                            <div
                                :style="$i18n.locale == 'zh' || $i18n.locale == 'hk' ? BusinessStyle1 : BusinessStyle2">
                                {{ $t('index.genset') }}</div>
                            <div
                                :style="$i18n.locale == 'zh' || $i18n.locale == 'hk' ? BusinessStyle3 : BusinessStyle4">
                                {{ $t('index.genset_description') }}</div>
                        </div>
                    </div>
                </el-col>
                <el-col :span="6" :xs="12" style="margin-bottom:20px">
                    <div style="background:#ffffff;height: 170px;" class="flex-row justify-center align-center">
                        <div style="cursor: pointer;text-align:center;flex-direction:column;"
                            @click="nav('productinfo?class_id=157&page=1&id=157')">
                            <el-image class="t1" style="width: 80px;height: 60px;margin-top: 15px;"
                                :src="require('@/assets/index/icon_generator.png')"></el-image>
                            <div
                                :style="$i18n.locale == 'zh' || $i18n.locale == 'hk' ? BusinessStyle1 : BusinessStyle2">
                                {{ $t('index.generator') }}</div>
                            <div
                                :style="$i18n.locale == 'zh' || $i18n.locale == 'hk' ? BusinessStyle3 : BusinessStyle4">
                                {{ $t('index.generator_description') }}</div>
                        </div>
                    </div>
                </el-col>
                <el-col :span="6" :xs="12" style="margin-bottom:20px">
                    <div style="background:#ffffff;height: 170px;" class="flex-row justify-center align-center">
                        <div style="cursor: pointer;text-align:center;flex-direction:column;"
                            @click="nav('productinfo?class_id=4&page=1&id=4')">
                            <el-image class="t1" style="width: 80px;height: 60px;margin-top: 15px;"
                                :src="require('@/assets/index/icon_engineering_machinery.png')"></el-image>
                            <div
                                :style="$i18n.locale == 'zh' || $i18n.locale == 'hk' ? BusinessStyle1 : BusinessStyle2">
                                {{ $t('index.engineering_machinery') }}</div>
                            <div
                                :style="$i18n.locale == 'zh' || $i18n.locale == 'hk' ? BusinessStyle3 : BusinessStyle4">
                                {{ $t('index.engineering_machinery_description') }}</div>
                        </div>
                    </div>
                </el-col>
                <el-col :span="6" :xs="12" style="margin-bottom:20px">
                    <div style="background:#ffffff;height: 170px;" class="flex-row justify-center align-center">
                        <div style="cursor: pointer;text-align:center;flex-direction:column;"
                            @click="nav('productinfo?class_id=2&page=1&id=2')">
                            <el-image class="t1" style="width: 80px;height: 60px;margin-top: 15px;"
                                :src="require('@/assets/index/icon_dualpower.png')"></el-image>
                            <div
                                :style="$i18n.locale == 'zh' || $i18n.locale == 'hk' ? BusinessStyle1 : BusinessStyle2">
                                {{ $t('index.low_voltage_equipment') }}</div>
                            <div
                                :style="$i18n.locale == 'zh' || $i18n.locale == 'hk' ? BusinessStyle3 : BusinessStyle4">
                                {{ $t('index.low_voltage_equipment_description') }}</div>
                        </div>
                    </div>
                </el-col>

                <el-col :span="6" :xs="12" style="margin-bottom:20px">
                    <div style="background:#ffffff;height: 170px;" class="flex-row justify-center align-center">
                        <div style="cursor: pointer;text-align:center;flex-direction:column;"
                            @click="nav('productinfo?class_id=69&page=1&id=69')">
                            <el-image class="t1" style="width: 80px;height: 60px;margin-top: 15px;"
                                :src="require('@/assets/index/icon_ship_control.png')"></el-image>
                            <div
                                :style="$i18n.locale == 'zh' || $i18n.locale == 'hk' ? BusinessStyle1 : BusinessStyle2">
                                {{ $t('index.ship_control') }}</div>
                            <div
                                :style="$i18n.locale == 'zh' || $i18n.locale == 'hk' ? BusinessStyle3 : BusinessStyle4">
                                {{ $t('index.ship_control_description') }}</div>
                        </div>
                    </div>
                </el-col>
                <el-col :span="6" :xs="12" style="margin-bottom:20px">
                    <div style="background:#ffffff;height: 170px;" class="flex-row justify-center align-center">
                        <div style="cursor: pointer;text-align:center;flex-direction:column;"
                            @click="nav('productinfo?class_id=12&page=1&id=12')">
                            <el-image class="t1" style="width: 80px;height: 60px;margin-top: 15px;"
                                :src="require('@/assets/index/monitor.png')"></el-image>
                            <div
                                :style="$i18n.locale == 'zh' || $i18n.locale == 'hk' ? BusinessStyle1 : BusinessStyle2">
                                {{ $t('index.monitoring') }}</div>
                            <div
                                :style="$i18n.locale == 'zh' || $i18n.locale == 'hk' ? BusinessStyle3 : BusinessStyle4">
                                {{ $t('index.monitoring_description') }}</div>
                        </div>
                    </div>
                </el-col>

                <el-col :span="6" :xs="12" style="margin-bottom:20px">
                    <div style="background:#ffffff;height: 170px;" class="flex-row justify-center align-center">
                        <div style="cursor: pointer;text-align:center;flex-direction:column;"
                            @click="nav('productinfo?class_id=62&page=1&id=62')">
                            <el-image class="t1" style="width: 80px;height: 60px;margin-top: 15px;"
                                :src="require('@/assets/index/module.png')"></el-image>
                            <div
                                :style="$i18n.locale == 'zh' || $i18n.locale == 'hk' ? BusinessStyle1 : BusinessStyle2">
                                {{ $t('index.module') }}</div>
                            <div
                                :style="[$i18n.locale == 'zh' || $i18n.locale == 'hk' ? BusinessStyle3 : BusinessStyle4, { maxWidth: '296px' }]">
                                {{ $t('index.module_description') }}
                            </div>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
        <div class="appmain home-title-wrapper">
            <div class="hometitle" @click="nav('productinfo')">{{ $t('index.NewProducts') }}</div>
            <el-row :gutter="20" style="margin-top:3%">
                <el-col :span="12" :xs="24" v-for="(item, index) in xinpin" :key="index">
                    <div style="cursor: pointer;background:#ffffff;margin-bottom: 4.8%" v-if="index == 0"
                        @click="nav(`product/${xinpinfirst.product_id}/${xinpinfirst.productModel}`)">
                        <div style="max-width:370px;margin:0 auto" class="t1">
                            <el-image style="width:100%" :src="xinpinfirst.get_image_list[0].product_img"></el-image>
                        </div>
                        <div class="chanpinname" style="padding-top:10px;height: 50px;">
                            {{ xinpinfirst.product_name }}
                        </div>
                        <div class="chanpinjieshao" style="padding-bottom: 30px;">{{ xinpinfirst.product_feature }}
                        </div>
                    </div>
                </el-col>
                <el-col :span="12" :xs="24">
                    <el-row :gutter="20">
                        <el-col :span="12" :xs="24" v-for="(item, index) in xinpin" :key="index"
                            style="cursor: pointer;">
                            <div style="background:#ffffff;margin-bottom: 4.8%"
                                @click="nav(`product/${item.product_id}/${encodeURIComponent(item.productModel)}`)">
                                <div class="chanpin2img t1">
                                    <el-image style="width:100%" :src="item.get_image_list[0].product_img"></el-image>
                                </div>
                                <div class="chanpinname" style="height: 40px;">
                                    {{ item.product_name }}
                                </div>
                                <div class="chanpinjieshao">{{ item.product_feature }}</div>
                            </div>
                        </el-col>
                    </el-row>
                </el-col>
            </el-row>
        </div>
        <div class="appmain home-title-wrapper">
            <div class="hometitle" @click="nav('applicationcase')">{{ $t('layout.application') }}</div>

            <el-row class="yyinfo">
                <el-col :span="11" :xs="24">
                    <div class="yyleft" @click="nav('projectinfo/' + anlifirst.project_id)">
                        <el-image style="width:100%" :src="require('@/assets/index/case1.png')"></el-image>
                        <div class="content">
                            <div style="width:80%;margin:0 auto;">
                                <div class="yydate">{{ anlifirst.ymd }}</div>
                                <div class="yytitle"
                                    @click.stop="nav('applicationcase?class_id=' + anlifirst.class_id)">
                                    {{ anlifirst.class_name }}</div>
                                <div class="yytitle">{{ anlifirst.project_title }}</div>
                                <div class="yyfubiao">{{ anlifirst.project_desc_text }}</div>
                            </div>
                        </div>
                    </div>
                </el-col>
                <el-col :span="13" :xs="24">
                    <el-col :span="12" :xs="24" v-for="(item, index) in anli" :key="index"
                        :style="{ 'margin-top': index == 2 || index == 3 ? '20px' : '0px' }">
                        <div class="yyright" @click="nav('projectinfo/' + item.project_id)">
                            <el-image style="width:100%" :src="item.backimg"></el-image>
                            <div class="content">
                                <div style="width:80%;margin:0 auto;">
                                    <div class="yydate">{{ item.ymd }}</div>
                                    <div class="yytitle" @click.stop="nav('applicationcase?class_id=' + item.class_id)">
                                        {{ item.class_name }}</div>
                                    <div class="yytitle">{{ item.project_title }}</div>
                                </div>
                            </div>
                        </div>
                    </el-col>
                </el-col>
            </el-row>
        </div>

        <div class="xuanze">
            <el-image class="hidden-xs-only xuanze-backimage" fit="cover"
                :src="require('@/assets/index/choose.jpg')"></el-image>
            <div class="wenzi">
                <div class="title">{{ $t('index.xuanze') }}</div>
                <div class="title2">
                    {{ $t('index.dizao') }}
                </div>
                <div class="neirong">
                    <div class="item dian">
                        <div class="titles right">
                            <div class="num">01</div>
                            <div class="xiaobiao">{{ $t('index.zishen') }}</div>
                        </div>
                        <div class="jieshao">
                            {{ $t('index.lingyu') }}
                        </div>
                    </div>

                    <div class="item dianl">
                        <div class="titles lefts">
                            <div class="num">02</div>
                            <div class="xiaobiao">{{ $t('index.yingyong') }}</div>
                        </div>
                        <div class="jieshao">
                            {{ $t('index.yytext') }}
                        </div>
                    </div>

                    <div class="item dian">
                        <div class="titles right">
                            <div class="num">03</div>
                            <div class="xiaobiao">{{ $t('index.rongyu') }}</div>
                        </div>
                        <div class="jieshao">
                            {{ $t('index.tixi') }}
                        </div>
                    </div>

                    <div class="item dianl">
                        <div class="titles lefts">
                            <div class="num">04</div>
                            <div class="xiaobiao">{{ $t('index.fengfu') }}</div>
                        </div>
                        <div class="jieshao">
                            {{ $t('index.chanpins') }}
                        </div>
                    </div>

                    <div class="item dian">
                        <div class="titles right">
                            <div class="num">05</div>
                            <div class="xiaobiao">{{ $t('index.yanfa') }}</div>
                        </div>
                        <div class="jieshao">
                            {{ $t('index.yongyou') }}
                        </div>
                    </div>

                    <div class="item dianl">
                        <div class="titles lefts">
                            <div class="num">06</div>
                            <div class="xiaobiao">{{ $t('index.zhuanye') }}</div>
                        </div>
                        <div class="jieshao">
                            {{ $t('index.zhuanyes') }}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="appmain home-title-wrapper">
            <div class="hometitle" @click="nav('news')">{{ $t('index.recentNews') }}</div>
        </div>


        <div class="dtinfo">
            <el-row :gutter="20">
                <el-col :span="8" :xs="24" v-for="(item, index) in dongtaifirst" :key="index">
                    <div class="dtleft" @click="nav('news_info/' + item.news_id)" style="padding-bottom:20px">
                        <el-image :src="item.news_img" style="width:100%;"></el-image>
                        <div
                            style="padding-left:2%;font-size: 16px;font-weight: bold;margin-top:10px;font-family: SourceHanSansCN-Medium;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
                            {{ item.news_title }}</div>
                        <div
                            style="padding-left:2%;font-size: 14px;color: rgba(51, 51, 51, 0.5);margin-top:10px;font-family: OPPOSans-M">
                            {{ item.ymd }}</div>
                    </div>
                </el-col>
                <el-col :span="8" :xs="24">
                    <div class="dtleft" style="padding:3%;padding-bottom:20px">
                        <div v-for="(item, index) in dongtai" :key="index" @click="nav('news_info/' + item.news_id)">
                            <div class="dttitle">{{ item.news_title }}</div>
                            <div class="dtdate">{{ item.ymd }}</div>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>
<script>
    // import { Message } from "element-ui"
    import {
        index,
        // productscollectAdd
    } from "@/api/api"
    export default {
        data() {
            return {
                title: '',
                imgHeight: "",
                banner: [],
                xinpinfirst: {},
                xinpin: [],
                anlifirst: {},
                anli: [],
                dongtaifirst: {},
                dongtai: [],
                autoplay: true,
                BusinessStyle1: {
                    marginTop: '6px',
                    fontSize: '17px',
                    fontWeight: 'bold'
                },
                BusinessStyle2: {
                    marginTop: '6px',
                    fontSize: '16px',
                    fontWeight: 'bold'
                },
                BusinessStyle3: {
                    textAlign: 'center',
                    fontSize: '13px',
                    maxWidth: '230px',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    marginTop: '5px'
                },
                BusinessStyle4: {
                    textAlign: 'center',
                    fontSize: '12px',
                    maxWidth: '230px',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    marginTop: '5px'
                }
            }
        },
        metaInfo() {
            return {
                title: this.title,
                meta: [
                    {
                        name: 'keyWords',
                        content: this.$t('seo.indexkeywords')
                    },
                    {
                        name: 'description',
                        content: this.$t('seo.indexdescription')
                    }
                ]
            }
        },
        created() {
            this.title = this.$t('layout.home') + '-' + this.$t('seo.indextitle')
            this.getList()
        },
        mounted() {
            this.imgLoad()
            // 监听窗口变化，使得轮播图高度自适应图片高度
            window.addEventListener("resize", () => {
                this.imgHeight = this.$refs.image[0].height
            })

            // 添加鼠标悬浮事件监听
            const carousels = document.querySelectorAll('.el-carousel')
            carousels.forEach(carousel => {
                carousel.addEventListener('mouseenter', () => {
                    this.autoplay = false
                })
                carousel.addEventListener('mouseleave', () => {
                    this.autoplay = true
                })
            })
        },
        methods: {
            async getList() {
                const { data: res } = await index()
                res.banner.forEach((item) => {
                    item.ori_img = process.env.VUE_APP_BASE_API + item.ori_img
                    item.carousel_img = process.env.VUE_APP_BASE_API + item.carousel_img
                })
                res.xinpin.forEach((item) => {
                    item.get_image_list.forEach((items) => {
                        items.product_img = process.env.VUE_APP_BASE_API + items.product_img
                    })
                })
                res.anli.forEach((item, index) => {
                    item.project_img = process.env.VUE_APP_BASE_API + item.project_img
                    if (index == 1) {
                        item.backimg = require('@/assets/index/case2.png')
                    } else if (index == 2) {
                        item.backimg = require('@/assets/index/case3.png')
                    } else if (index == 3) {
                        item.backimg = require('@/assets/index/case5.png')
                    } else if (index == 4) {
                        item.backimg = require('@/assets/index/case4.png')
                    }
                })
                res.dongtai.forEach((item) => {
                    item.news_img = process.env.VUE_APP_BASE_API + item.news_img
                })
                this.xinpinfirst = res.xinpin[0]
                this.anlifirst = res.anli[0]
                this.banner = res.banner
                this.xinpin = res.xinpin.splice(1)
                this.anli = res.anli.splice(1)
                this.dongtaifirst = [res.dongtai[0], res.dongtai[1]]
                this.dongtai = res.dongtai.splice(2)
            },
            imgLoad() {
                this.$nextTick(function () {
                    // 获取窗口宽度*图片的比例，定义页面初始的轮播图高度
                    this.imgHeight = document.body.clientWidth * 0.8 / 3.5
                })
            },
            nav(item) {
                this.$router.push('/' + item, '_blank')
            },
            bantiao(item) {
                let items = process.env.VUE_APP_HOST + item
                window.open(items, '_blank')
            }
        }
    }
</script>
<style lang="scss" scoped>
    .t1:hover {
        // -webkit-animation:sucaijiayuan 1s .1s ease both;
        // -moz-animation:tada 1s .1s ease both;
        transform: scale(1.2);
    }

    @-webkit-keyframes sucaijiayuan {
        0% {
            -webkit-transform: scale(1)
        }

        10%,
        20% {
            -webkit-transform: scale(1) rotate(-2deg)
        }

        30%,
        50%,
        70%,
        90% {
            -webkit-transform: scale(1.1) rotate(2deg)
        }

        40%,
        60%,
        80% {
            -webkit-transform: scale(1.1) rotate(-2deg)
        }

        100% {
            -webkit-transform: scale(1) rotate(0)
        }
    }

    .lunbo {
        margin-top: 0;
        // min-width: 1280px;
    }

    .home-title-wrapper {
        text-align: center;
    }

    .hometitle {
        font-size: 24px;
        line-height: 24px;
        font-family: SourceHanSansCN-Bold;
        font-weight: bold;
        color: #333333;
        margin-top: 50px;
        cursor: pointer;
        position: relative;
        margin-bottom: 20px;

        &::after {
            content: "";
            display: inline-block;
            position: absolute;
            width: 32px;
            height: 2px;
            background: #0052D9;
            bottom: -10px;
            left: 50%;
            transform: translateX(-16px);
        }

    }

    .chanpin2img {
        width: 152px;
        margin: 0 auto;
    }

    .chanpinname {
        font-size: 17px;
        color: #333333;
        text-align: center;
        font-family: OPPOSans-H;
        margin-top: 2px;
    }

    .chanpinjieshao {
        font-size: 14px;
        font-family: SourceHanSansCN-Regular;
        font-weight: 400;
        color: rgba(51, 51, 51, 0.6);
        text-align: center;
        line-height: 18px;
        margin-top: 5px;
        text-overflow: ellipsis;
        /*让截断的文字显示为点点。还有一个值是clip意截断不显示点点*/
        white-space: nowrap;
        /*让文字不换行*/
        overflow: hidden;
        /*超出要隐藏*/
        padding-bottom: 10px;
        padding-left: 4%;
        padding-right: 4%;
    }

    .yyinfo {
        .yydate {
            font-size: 16px;
            color: #FFFFFF;
            font-weight: 500;
            font-family: OPPOSans-M;
        }

        .yytitle {
            margin-top: 15px;
            font-size: 18px;
            font-weight: bold;
            line-height: 30px;
        }

        .yyfubiao {
            margin-top: 15%;
            font-size: 16px;
            line-height: 34px;
            font-weight: 400;
            font-family: SourceHanSansCN-Normal;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 6;
            overflow: hidden;
            word-break: break-all;
        }

        .yyleft {
            width: 100%;
            margin: 0 auto;
            position: relative;
            cursor: pointer;

            .content {
                width: 100%;
                position: absolute;
                top: 8%;
                z-index: 2;
                color: #FFFFFF;
            }
        }

        .yyright {
            width: 96%;
            margin: 0 auto;
            margin-left: 5%;
            position: relative;
            cursor: pointer;

            .content {
                width: 100%;
                position: absolute;
                top: 15%;
                z-index: 2;
                color: #FFFFFF;
            }
        }
    }

    .dtinfo {
        width: 1280px;
        margin: 0 auto;

        .dtleft {
            width: 100%;
            background: #FFFFFF;
            cursor: pointer;

            .dttitle {

                font-family: SourceHanSansCN-Medium;
                font-size: 16px;
                font-weight: bold;
                color: #333333;
                margin-top: 12px;
                text-overflow: ellipsis;
                /*让截断的文字显示为点点。还有一个值是clip意截断不显示点点*/
                white-space: nowrap;
                /*让文字不换行*/
                overflow: hidden;
                /*超出要隐藏*/
            }

            .dtdate {
                font-size: 12px;
                font-family: OPPOSans-M;
                font-weight: normal;
                color: rgba(51, 51, 51, 0.5);
                margin-top: 10px;
            }
        }
    }

    .xuanze {
        margin-top: 100px;
        width: 100%;
        position: relative;
        min-width: 1280px;


        .xuanze-backimage {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            z-index: -1;
        }

        .wenzi {
            width: 1280px;
            padding: 60px 0;
            margin: 0 auto;

            .title {
                font-family: SourceHanSansCN-Bold;
                text-align: center;
                font-weight: bold;
                color: #FFFFFF;
                font-size: 24px;
                position: relative;
                margin-bottom: 30px;

                &::after {
                    content: "";
                    display: inline-block;
                    position: absolute;
                    width: 32px;
                    height: 2px;
                    bottom: -10px;
                    left: 50%;
                    transform: translateX(-16px);
                    background-color: #FFFFFF;
                }
            }

            .title2 {
                text-align: center;
                font-size: 18px;
                font-family: SourceHanSansCN-Regular;
                font-weight: 400;
                color: #FFFFFF;
            }

            .neirong {
                margin-top: 20px;

                width: 100%;
                display: grid;
                grid-template-columns: 1fr 1fr;
                gap: 20px;

                .item {
                    width: 100%;
                    // min-height: 200px;
                    background: #FFFFFF;
                    padding: 20px 30px;
                    cursor: pointer;
                    position: relative;

                    .titles {
                        line-height: 30px;
                        display: flex;
                        margin-top: 3%;

                        .num {
                            color: #0052D9;
                            font-size: 20px;
                            font-family: OPPOSans-H;
                            margin-right: 10px;
                            line-height: 35px;
                        }

                        .xiaobiao {
                            font-family: SourceHanSansCN-Bold;
                            font-weight: bold;
                            color: #000000;
                            font-size: 20px;
                        }
                    }

                    .jieshao {
                        margin-top: 10px;
                        color: #333333;
                        font-size: 16px;
                        font-family: SourceHanSansCN-Regular;
                        font-weight: 400;
                        text-align: justify;
                        line-height: 23px;
                    }

                    .lefts {
                        justify-content: flex-start;
                    }

                    .right {
                        justify-content: flex-end;
                    }
                }

                .dian::after,
                .dianl::after {
                    content: "";
                    width: 10px;
                    height: 24px;
                    position: absolute;
                    background: #2DC84D;
                    top: 40px;
                    display: none;
                }

                .dianl::after {
                    left: 0;
                }

                .dian::after {
                    right: 0;
                }

                .item:hover {
                    background: #0052D9;

                    &::after {
                        display: block;
                    }


                    .titles {
                        .num {
                            color: #fff;
                        }

                        .xiaobiao {
                            color: #fff;
                        }
                    }

                    .jieshao {
                        color: #fff;
                    }
                }
            }
        }
    }

    @media screen and (max-width: 767px) {
        .chanpin2img {
            max-width: 350px !important;
            width: 100%;
        }

        .yyinfo {
            width: 100%;

            .yytitle {
                font-size: 14px;
            }

            .yyleft {
                width: 100%;
                margin: 0 auto;
                position: relative;

                .content {
                    position: absolute;
                    top: 8%;
                    z-index: 2;
                    color: #FFFFFF;
                }
            }

            .yyright {
                width: 100%;
                margin: 0 auto;
                position: relative;

                .content {
                    position: absolute;
                    top: 5%;
                    z-index: 2;
                    color: #FFFFFF;
                }
            }
        }

        .dtinfo {
            width: 100%;
            padding: 0;
        }

        .xuanze {
            width: 100%;
            min-width: unset;

            .wenzi {
                width: 100%;
                padding: 0;

                .title {
                    font-family: SourceHanSansCN-Bold, SourceHanSansCN;
                    text-align: center;
                    font-weight: bold;
                    color: #333333;
                    font-size: 24px;
                    margin-top: 20px;
                }

                .title2 {
                    text-align: center;
                    font-size: 18px;
                    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
                    font-weight: 400;
                    color: #333333;
                }

                .neirong {
                    width: 100%;
                    grid-template-columns: 1fr;

                    .item {
                        width: 100%;
                        background: rgba(179, 179, 179, 0.746);
                        margin-top: 5%;

                        .jieshao {
                            font-size: 13.5px;
                        }
                    }
                }
            }
        }
    }

</style>